'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i['return']) _i['return']();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError('Invalid attempt to destructure non-iterable instance');
    }
  };
}();

var _util = require('./util');

var _inject = require('./inject');

var StyleSheet = {
  create: function create(sheetDefinition) {
    return (0, _util.mapObj)(sheetDefinition, function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2);

      var key = _ref2[0];
      var val = _ref2[1];
      return [key, {
        // TODO(emily): Make a 'production' mode which doesn't prepend
        // the class name here, to make the generated CSS smaller.
        _name: key + '_' + (0, _util.hashObject)(val),
        _definition: val
      }];
    });
  },
  rehydrate: function rehydrate() {
    var renderedClassNames = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
    (0, _inject.addRenderedClassNames)(renderedClassNames);
  }
};
/**
 * Utilities for using Aphrodite server-side.
 */

var StyleSheetServer = {
  renderStatic: function renderStatic(renderFunc) {
    (0, _inject.reset)();
    (0, _inject.startBuffering)();
    var html = renderFunc();
    var cssContent = (0, _inject.flushToString)();
    return {
      html: html,
      css: {
        content: cssContent,
        renderedClassNames: (0, _inject.getRenderedClassNames)()
      }
    };
  }
};
/**
 * Utilities for using Aphrodite in tests.
 *
 * Not meant to be used in production.
 */

var StyleSheetTestUtils = {
  /**
   * Prevent styles from being injected into the DOM.
   *
   * This is useful in situations where you'd like to test rendering UI
   * components which use Aphrodite without any of the side-effects of
   * Aphrodite happening. Particularly useful for testing the output of
   * components when you have no DOM, e.g. testing in Node without a fake DOM.
   *
   * Should be paired with a subsequent call to
   * clearBufferAndResumeStyleInjection.
   */
  suppressStyleInjection: function suppressStyleInjection() {
    (0, _inject.reset)();
    (0, _inject.startBuffering)();
  },

  /**
   * Opposite method of preventStyleInject.
   */
  clearBufferAndResumeStyleInjection: function clearBufferAndResumeStyleInjection() {
    (0, _inject.reset)();
  }
};

var css = function css() {
  for (var _len = arguments.length, styleDefinitions = Array(_len), _key = 0; _key < _len; _key++) {
    styleDefinitions[_key] = arguments[_key];
  }

  var useImportant = true; // Append !important to all style definitions

  return (0, _inject.injectAndGetClassName)(useImportant, styleDefinitions);
};

exports['default'] = {
  StyleSheet: StyleSheet,
  StyleSheetServer: StyleSheetServer,
  StyleSheetTestUtils: StyleSheetTestUtils,
  css: css
};
module.exports = exports['default'];